import OrganizationSuspended from './organizationSuspended';

export default OrganizationSuspended;
